import { API_BASE_URL } from '../config.js';

export class ApiError extends Error {
  constructor(message, { status, payload } = {}) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.payload = payload;
  }
}

function translateError(payload, status) {
  const code = payload?.error?.code;
  if (!code) return null;

  const map = {
    UNAUTHENTICATED: 'Vous devez être connecté·e.',
    NO_FAMILY: "Vous devez d'abord rejoindre votre couple.",
    ADMIN_SECRET_REQUIRED: 'Secret admin requis.',
    INVALID_ADMIN_SECRET: 'Secret admin invalide.',
    INVALID_INPUT: 'Informations invalides.',
    INVALID_CREDENTIALS: 'Email ou mot de passe incorrect.',
    EMAIL_ALREADY_USED: 'Cet email est déjà utilisé.',
    EMAIL_ALREADY_REGISTERED: 'Cet email est déjà enregistré.',
    EMAIL_ALREADY_USED_IN_FAMILY: 'Cet email est déjà utilisé dans ce foyer.',
    EMAIL_NOT_VERIFIED: "Cette adresse email n'est pas encore verifiee.",
    INVALID_INVITE_CODE: "Code d'invitation invalide.",
    INVALID_TOKEN: 'Ce lien est invalide.',
    ALREADY_IN_FAMILY: 'Vous appartenez déjà à un couple.',
    NOT_IMPLEMENTED: "Cette fonctionnalité n'est pas encore disponible.",
    RATE_LIMITED: 'Trop de tentatives. Reessayez dans quelques minutes.',
    TOKEN_EXPIRED: 'Ce lien a expire.',
    SERVER_ERROR: 'Une erreur est survenue. Réessayez.',
    SERVER_MISCONFIG: 'Configuration serveur manquante.'
  };

  if (map[code]) return map[code];
  // Generic fallback
  if (status >= 500) return 'Une erreur est survenue. Réessayez.';
  return null;
}

async function readJsonSafely(res) {
  try {
    return await res.json();
  } catch (e) {
    return null;
  }
}

export async function apiFetch(path, { token, method = 'GET', body, headers } = {}) {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(headers || {})
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {})
  });

  const payload = await readJsonSafely(res);
  if (!res.ok) {
    const translated = translateError(payload, res.status);
    const msg = translated || payload?.error?.message || `Erreur (${res.status})`;
    throw new ApiError(msg, { status: res.status, payload });
  }
  return payload;
}

